<template>
    <el-select v-model="modelValue" placeholder="请选择数据类型" @change="handleChange">
        <el-option v-if="isAllItem" label="全部" :value="''"></el-option>
        <el-option
            v-for="item in dataTypeOptions"
            :key="item.value"
            :label="item.name"
            :value="item.value">
        </el-option>
    </el-select>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        isAllItem: {
            type: Boolean,
            default: true
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    data() {
        return {

        }
    },
    computed: {
        ...mapState({
            dataTypeOptions: 'dataTypeOptions'
        }),
        modelValue: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        }
    },
    mounted() {
        if (this.dataTypeOptions.length === 0) {
            this.getDataTypeOptions()
        }
    },
    methods: {
        ...mapActions({
            getDataTypeOptions: 'getDataTypeOptions'
        }),
        handleChange(v) {
            this.$emit('change', v)
        }
    }
}
</script>
<style scoped lang="less">

</style>